import { Controller } from "@hotwired/stimulus"

const STATUS_COLORS = {
  "touch_base_1":                   { bg: "#f4d8e4", text: "#68354e" },
  "touch_base_2":                   { bg: "#f4d8e4", text: "#68354e" },
  "touch_base_2_completed":         { bg: "#d7e6dd", text: "#2a533c" },
  "renewal":                        { bg: "#f2e3b7", text: "#655121" },
  "renewal_cs_1":                   { bg: "#f4d8e4", text: "#68354e" },
  "renewal_reschedule":             { bg: "#e5e7eb", text: "#4b5563" },  // default grey
  "renewal_zoom_booked":            { bg: "#e8dbf2", text: "#5b416e" },
  "renewal_follow_up":              { bg: "#e8dbf2", text: "#5b416e" },
  "renewal_no_show_rebook":         { bg: "#e8dbf2", text: "#5b416e" },
  "renewal_no_show_call_2_cs_only": { bg: "#e5e7eb", text: "#4b5563" },  // default grey
  "renewal_link_sent":              { bg: "#d7e6dd", text: "#2a533c" },
  "auto_renew":                     { bg: "#f4dfcf", text: "#6a4222" },
  "update_portal":                  { bg: "#cbe3f7", text: "#264a72" },
  "renewed":                        { bg: "#d7e6dd", text: "#2a533c" },
  "yr_12_renewed":                  { bg: "#d7e6dd", text: "#2a533c" },
  "did_not_renew":                  { bg: "#f7d9d5", text: "#6d3531" },
  "program_ended":                  { bg: "#f7d9d5", text: "#6d3531" },
  "left_program_early":             { bg: "#f7d9d5", text: "#6d3531" },
  "in_client_happiness":            { bg: "#f7d9d5", text: "#6d3531" },
  "locked_out":                     { bg: "#f7d9d5", text: "#6d3531" },
  "no_show":                        { bg: "#dfd2c8", text: "#594639" },  // brown/beige
  "declined_renewal_call":          { bg: "#e5e7eb", text: "#4b5563" },
  "inactive":                       { bg: "#e5e7eb", text: "#4b5563" },
  "moved_tb2026":                   { bg: "#dfd2c8", text: "#594639" },  // same as no_show
}

export default class extends Controller {
  static targets = ["select"]

  connect() {
    this.dropdown = null
    this.badge = null
    this.selectTarget.classList.add("hidden")
    this._buildUI()
    this._outsideClickHandler = this._handleOutsideClick.bind(this)
    document.addEventListener("click", this._outsideClickHandler)
  }

  disconnect() {
    document.removeEventListener("click", this._outsideClickHandler)
  }

  _buildUI() {
    const select = this.selectTarget

    const wrapper = document.createElement("div")
    wrapper.style.position = "relative"

    // Trigger button
    const trigger = document.createElement("button")
    trigger.type = "button"
    trigger.className = "mt-1 flex items-center w-full pl-3 pr-10 py-2 border border-gray-300 sm:text-sm rounded-md bg-white cursor-pointer text-left relative"
    trigger.addEventListener("click", (e) => {
      e.stopPropagation()
      this.dropdown.classList.toggle("hidden")
    })

    this.badge = document.createElement("span")
    this._applyBadgeStyle(this.badge, select.value)

    const chevron = document.createElement("span")
    chevron.style.cssText = "position: absolute; right: 10px; top: 50%; transform: translateY(-50%); pointer-events: none; color: #9ca3af;"
    chevron.innerHTML = `<svg width="16" height="16" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"/></svg>`

    trigger.appendChild(this.badge)
    trigger.appendChild(chevron)

    // Dropdown list
    this.dropdown = document.createElement("ul")
    this.dropdown.className = "hidden"
    this.dropdown.style.cssText = "position: absolute; z-index: 30; width: 100%; background: white; border: 1px solid #e5e7eb; border-radius: 6px; box-shadow: 0 4px 12px rgba(0,0,0,0.1); margin-top: 4px; padding: 4px 0; max-height: 14rem; overflow-y: auto;"

    // None option
    const blankLi = document.createElement("li")
    blankLi.style.cssText = "padding: 6px 12px; cursor: pointer; font-size: 13px; color: #6b7280;"
    blankLi.textContent = "None" 
    blankLi.addEventListener("mouseenter", () => blankLi.style.background = "#f9fafb")
    blankLi.addEventListener("mouseleave", () => blankLi.style.background = "")
    blankLi.addEventListener("click", () => this._select(""))
    this.dropdown.appendChild(blankLi)

    Array.from(select.options).forEach(option => {
      if (!option.value) return
      const li = document.createElement("li")
      li.style.cssText = "padding: 6px 12px; cursor: pointer;"
      li.addEventListener("mouseenter", () => li.style.background = "#f9fafb")
      li.addEventListener("mouseleave", () => li.style.background = "")
      li.addEventListener("click", () => this._select(option.value))

      const span = document.createElement("span")
      this._applyBadgeStyle(span, option.value)
      li.appendChild(span)
      this.dropdown.appendChild(li)
    })

    wrapper.appendChild(trigger)
    wrapper.appendChild(this.dropdown)
    select.insertAdjacentElement("afterend", wrapper)
  }

  _select(value) {
    this.selectTarget.value = value
    this._applyBadgeStyle(this.badge, value)
    this.dropdown.classList.add("hidden")
  }

  _applyBadgeStyle(el, value) {
    const colors = STATUS_COLORS[value]
    const option = this.selectTarget.querySelector(`option[value="${value}"]`)
    const label = option?.textContent || (value === "" ? "None" : value.replace(/_/g, " ").replace(/\b\w/g, c => c.toUpperCase()))

    el.textContent = label
    el.style.cssText = `
      display: inline-block;
      padding: 2px 10px;
      border-radius: 4px;
      font-size: 13px;
      font-weight: 500;
      background: ${colors?.bg || "#e5e7eb"};
      color: ${colors?.text || "#374151"};
      border: ${colors?.border || "none"};
    `
  }

  _handleOutsideClick(e) {
    if (!this.element.contains(e.target)) {
      this.dropdown?.classList.add("hidden")
    }
  }
}